import React from "react";
import {
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineYoutube,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { logo } from "../assets";

const Footer = () => {
  const [activeNav, setActiveNav] = React.useState("Home");
  const navigate = useNavigate();
  const navigations = [
    {
      name: "Home",
      href: "/",
    },
    {
      name: "Gallery",
      href: "gallery",
    },
    {
      name: "Contact",
      href: "/#contact",
    },
  ];
  return (
    <footer
      id="footer"
      className="lg:px-10 lg:py-40 p-5 sm:p-24 bg-[#202020] md:rounded-t-[72px]"
    >
      <div className="md:flex md:justify-evenly md:gap-14">
        <div className="grid text-[#B6B6B6] grid-cols-2 gap-7 sm:grid-cols-3">
          <div>
            <h2 className="mb-4 underline text-[18px] font-bold uppercase">
              GET IN TOUCH
            </h2>
            <ul className="flex flex-col">
              <a
                href="mailto:lighxr@otherlogic.in"
                className="mb-4 flex items-center gap-1 underline"
              >
                <span className="break-keep">lighxr@otherlogic.in</span>
              </a>
              <a
                href="mailto:nihar@otherlogic.in"
                className="mb-4 flex items-center gap-1 underline"
              >
                <span className="break-keep">Nihar@otherlogic.in</span>
              </a>
              <a
                href="mailto:kartikey@otherlogic.in"
                className="mb-4 flex items-center gap-1 underline"
              >
                <span className="break-keep">Kartikey@otherlogic.in</span>
              </a>
            </ul>
          </div>
          <div>
            <h2 className="mb-4 underline text-[18px] font-bold uppercase">
              STAY UPDATED
            </h2>
            <ul className="flex flex-col">
              <a href="#" className="mb-4 flex items-center gap-4 underline">
                <AiOutlineInstagram />
                <span className="break-keep">Instagram</span>
              </a>
              <a href="#" className="mb-4 flex items-center gap-4 underline">
                <AiOutlineLinkedin />
                <span className="break-keep">LinkedIn</span>
              </a>
              <a href="#" className="mb-4 flex items-center gap-4 underline">
                <AiOutlineYoutube />
                <span className="break-keep">Youtube</span>
              </a>
            </ul>
          </div>
          <div>
            <h2 className="mb-4 underline text-[18px] font-bold uppercase">
              STUDIO ADDRESS
            </h2>
            <ul className="">
              <li className="mb-4">
                Studio: C-56 LGF, Block C, <br />
                Greenwood City, Sector 45, <br />
                Gurugram, Haryana 122003
              </li>
            </ul>
          </div>
        </div>
        <div className=" mb-6 md:mb-0">
          <span
            onClick={() => window.scrollTo(0, 0)}
            className="flex mb-20 flex-col items-center cursor-pointer"
          >
            <img className="w-44 -mb-8" src={logo} alt="logo" />
          </span>
        </div>
      </div>
      <div className="flex justify-center mt-20">

      <div className="lg:flex justify-center w-[380px] hidden bg-[#D9D9D9BF] rounded-[50px] text-[12px] px-1 py-1 text-white gap-5">
        {navigations.map((navigation) => (
          <a
            onClick={() => {
              navigate(navigation.href);
              setActiveNav(navigation.name);
            }}
            className={`${activeNav === navigation.name ? "bg-[#151515]" : "text-black"
              } rounded-[50px] px-8 py-1 flex items-center cursor-pointer`}
          >
            {navigation.name}
          </a>
        ))}
      </div>
      </div>
    </footer>
  );
};

export default Footer;
